<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('topUp.title') }}</h2>
      <p class="text-center">
        {{ $t('topUp.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <top-ups-filter-form :filter-details="filterDetails"/>
      </div>
      <div class="col-12" v-loading="loading"/>
    </div>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div class="row mt-2" v-if="!loading && filterDetails && !error">
      <div class="col-12">
        <top-ups-table :details="topUpsData" :pagination-details="pagination"
                       :filter-details="filterDetails"/>
      </div>
    </div>
  </div>
</template>
<script>
import TopUpsTable from 'src/components/TopUp/TopUpsTable'
import TopUpsFilterForm from './TopUpsFilterForm'
import {mapState} from "vuex";
import {BaseAlert} from 'src/components';

export default {
  name: 'top-ups',
  components: {
    TopUpsFilterForm,
    TopUpsTable,
    BaseAlert
  },
  methods: {},
  computed: {
    ...mapState({
      loading: state => state.top_ups.loading,
      topUpsData: state => state.top_ups.data,
      pagination: state => state.top_ups.pagination,
      filterDetails: state => state.top_ups.filterDetails,
      error: state => state.top_ups.error,
    }),
  },
};
</script>
<style>
</style>
